import http from 'hub-http/clients/apiClient';
const fetchCallSummaryHistory = ({
  objectId
}) => {
  return http.get(`crm/v3/objects/CALL/${objectId}?propertiesWithHistory=hs_call_summary`);
};
export default fetchCallSummaryHistory;